<script lang="ts" setup>
	import { twMerge, type ClassNameValue } from 'tailwind-merge'
	import type { RouteLocationAsRelativeGeneric } from 'vue-router'
	import type { ClassContext } from '~/types'

	const { text = '', type = 'outline' } = defineProps<{
		text?: string
		type?: 'primary' | 'outline'
		href?: string | RouteLocationAsRelativeGeneric
	}>()
	const attr = useAttrs()
	const className = computed(() => (attr?.class || '') as ClassNameValue)
	defineOptions({ inheritAttrs: false })
	const classList = computed(() =>
		twMerge([
			type === 'outline'
				? 'border-[#6FD9BB] bg-[#E2F7F1] hover:bg-[#D1FADF] text-[#092A25] '
				: 'bg-[#092A25] text-white hover:bg-[#092A25CC]',
			'md:py-[16px] md:px-[18px] py-[15px] px-[25px] rounded-[81px] border md:min-w-[128px] font-semibold text-sm custom-transition-3',
			className.value
		])
	)
	defineEmits<{
		(event: 'click'): void
		(event: 'trigger'): void
	}>()
</script>
<template>
	<nuxt-link v-if="href" :to="href" :class="classList" @click="$emit('click')">
		<slot>
			{{ text }}
		</slot>
	</nuxt-link>
	<button v-else type="button" :class="classList" @click="$emit('trigger')">
		<slot>
			{{ text }}
		</slot>
	</button>
</template>
